// chakra imports
import { Box, Flex, Stack } from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import SidebarCard from "components/sidebar/components/SidebarCard";
import React from "react";



function SidebarContent(props) {
  const { routes } = props;

  return (
    <Box w="100%" display="flex" flexDirection="column" alignItems="flex-start">
      <Links routes={routes} />
    </Box>
  );
}

export default SidebarContent;
